/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var AttachPinIcon16Solid = forwardRef('AttachPinIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M10.713.863C10.08.23 9.005.68 9.005 1.57c0 .862-.342 1.69-.951 2.299l-.18.18a3.25 3.25 0 0 1-2.299.952H3.163c-1.114 0-1.671 1.347-.884 2.134l2.586 2.586-3.073 3.072a1 1 0 1 0 1.415 1.414l3.072-3.072 2.584 2.584c.788.788 2.134.23 2.134-.883v-2.413c0-.862.342-1.688.952-2.298l.18-.18a3.25 3.25 0 0 1 2.3-.953c.889 0 1.337-1.076.706-1.707L10.713.863Z" })));
});
